<template>
  <BaseModal ref="modal" modal-classes="max-w-md mx-auto" @modal-after-leave="$emit('closed')">
    <template #header>
      <span class="block text-xs text-gray-700 uppercase tracking-wider">project</span>
      <h3 class="text-2xl text-gray-900">Προσθήκη σε Project</h3>
    </template>

    <template #default="modalProps">
      <OrderProjectForm
        :client-relation-uuid="clientRelationUuid"
        :account-uuid="accountUuid"
        :client-uuid="clientUuid"
        :project-uuid.sync="computedProjectUuid"
        :default-project-name="defaultProjectName"
        @success="modalProps.close"
      />
    </template>
  </BaseModal>
</template>

<script>
import OrderProjectForm from './OrderProjectForm.vue';

export default {
  components: {
    OrderProjectForm,
  },

  props: {
    clientRelationUuid: {
      type: String,
      required: true,
    },
    accountUuid: {
      type: String,
      required: true,
    },
    clientUuid: {
      type: String,
      required: true,
    },
    projectUuid: {
      type: String,
      default: null,
    },
    defaultProjectName: {
      type: String,
      default: '',
    },
  },

  computed: {
    computedProjectUuid: {
      get() {
        return this.projectUuid;
      },
      set(value) {
        this.$emit('update:project-uuid', value);
      },
    },
  },
};
</script>
